import React from "react";
import MUIButton, { ButtonProps as MUIButtonProps } from "@mui/material/Button";

export type ButtonProps = MUIButtonProps;

const Button = (props: MUIButtonProps & { target?: string }) => {
    return (
        <MUIButton
            variant={props.variant ?? "contained"}
            color={props.color ?? "primary"}
            {...props}
        />
    );
};

export default Button;
